
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { SHARE_DC } from '@mainrepo/app/core/constants/ShareDCURLs';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { FileOperationsImplementation } from '../implementation/FileOperationsImplementation';
import { GlobalService } from '../services/global.service';
import { LocalStorageSvc } from '../services/localStorage.service';
import { Controller } from './Controller';

export class FileOperationsController extends Controller{
  public fileOperationsImplementation: any;
  public universalService: any;
  public static singleInstance: any = null;
  public listService:any;
  public router:any;
  loggerService: any;
  localStorageSvc: LocalStorageSvc;
  currentTabController:any;
  containerHeightCalc:any;
  cleverTapEventsService: any;
  dcGroupCodePicker: any;
  sessionStorageService: any;
  
  public constructor(public globalService:GlobalService) {
    super(globalService)
    this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
    this.fileOperationsImplementation.setHandler(this.globalService)
    this.setEnvObjects(globalService);
  }

  public static getInstance(globalService): FileOperationsController {
    if (this.singleInstance == null) {
      this.singleInstance = new FileOperationsController(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }


  setEnvObjects(globalService){
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.router = globalService.getRouterRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
    this.containerHeightCalc = this.globalService.getContainerHeightCalculatorService();
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
  }


  async getFolders(sortType){ //common
    this.universalService.showLoader = true;
    var url;
    this.checkIfFolderKeysIsEmpty();

    var type = "";
    let limit;
    var folderKey = this.fileOperationsImplementation.folderKeys[this.fileOperationsImplementation.folderKeys.length - 1]
    type = (folderKey == this.fileOperationsImplementation.folderKeys[0])?"&type=w":"";
    limit = (folderKey == this.fileOperationsImplementation.folderKeys[0])?"limit=2000":"limit=300";
      url = ENV_CONFIG["commonUrls"]["nmsMetaData"] +"?" + limit +"&folderKey=" + folderKey  + "&sort="+sortType + type;
    
    var foldersUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + url;
    this.fileOperationsImplementation.setHandler(this.globalService)
    this.fileOperationsImplementation.getFolders(foldersUrl);
    if(this.universalService.popUpToBeOpened == "movePopUp"){
      this.universalService.movePopupOpenFolderKey[0]=this.fileOperationsImplementation.folderKeys[this.fileOperationsImplementation.folderKeys.length - 1]
    }
  }


  async getPrivateFolders(sortType){ //common
    this.universalService.showLoader = true;
    var url;
    this.checkIfFolderKeysIsEmpty();

    var type = "";
    let limit;
    var folderKey = this.fileOperationsImplementation.folderKeys[this.fileOperationsImplementation.folderKeys.length - 1]
    type = (folderKey == this.fileOperationsImplementation.folderKeys[0])?"&type=w":"";
    limit = (folderKey == this.fileOperationsImplementation.folderKeys[0])?"limit=2000":"limit=300";
    await this.listService.getPPFToken();
    url = ENV_CONFIG["commonUrls"]["nmsMetaData"] + "/ppf?" + limit +"&folderKey=" + folderKey  + "&sort="+sortType + type;

    var foldersUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + url;
    this.fileOperationsImplementation.setHandler(this.globalService)
    this.fileOperationsImplementation.getFolders(foldersUrl);
    if(this.universalService.popUpToBeOpened == "movePopUp"){
      this.universalService.movePopupOpenFolderKey[0]=this.fileOperationsImplementation.folderKeys[this.fileOperationsImplementation.folderKeys.length - 1]
    }
  }


  async getSharedWithMeFolders(sortType){
    this.universalService.showLoader = true;
    var folderNames = this.fileOperationsImplementation.folderNames
    var url;
    if(this.fileOperationsImplementation.folderNames.length == 1){
      url = ENV_CONFIG.commonUrls["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["sharedWithMe"] + ENV_CONFIG.commonUrls["folders"];
    }else{
      url = ENV_CONFIG.commonUrls["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + "/" + folderNames[folderNames.length-1]["shareKey"] + ENV_CONFIG.commonUrls["nestedFolder"]  + "/" + folderNames[folderNames.length-1]["objectKey"];
    }
    var foldersUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + url;
    this.fileOperationsImplementation.setHandler(this.globalService)
    await this.fileOperationsImplementation.getFolders(foldersUrl);
  }

  async getTeamFolders() {
    this.universalService.showLoader = true;
    var folderNames = this.fileOperationsImplementation.folderNames
    var limit = (this.universalService.popUpToBeOpened == "copyPopUp") ? "2000" : "100";
    let url = "";
    if(this.fileOperationsImplementation.folderNames.length == 1) {
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["userTeamFolders"] + '?limit=' + limit;
    } else {
      url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["nonadminTeamFolderMetadataOptimised"];
      url += "?folderKey=" + folderNames[folderNames.length-1]["objectKey"] + "&tfKey=" + folderNames[folderNames.length-1]["tfKey"] + "&type=w" + "&limit="+limit+this.listService.listViewSortOrder;
    }
    this.fileOperationsImplementation.setHandler(this.globalService)
    await this.fileOperationsImplementation.getFolders(url);
  }


  async getAlbums(tab){ //common
    // var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + "/boards/sync/initial?page=0&limit=2000";
    var albumType = "p";
    var url  = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumsList"] + "?page=0&limit=2000";
    if(tab == 'sharedAlbums'){
      albumType = 's';
    }
    url = url + '&albumType=' + albumType;
    this.fileOperationsImplementation.setHandler(this.globalService)
    try{
      var result =  await  this.fileOperationsImplementation.getAlbums(url);
      this.loggerService.log("albums from file ops controller",result)
      if(this.universalService.isMobileDevice){
        this.setAlbumsContHeight();
      }
      this.universalService.showLoader = false;
      return result;
    }catch(exc){
      this.loggerService.log("exception in get albums",exc)
    }
    
  }

  setAlbumsContHeight(){
    this.containerHeightCalc.calculateHeight('.addToJioCloudAlbumCont',['.addToJioCloudAlbumCont .modal-header','.addToJioCloudAlbumCont .modal-footer'],170)
  }

  async createFolder(folderName){ //common
    this.fileOperationsImplementation.setHandler(this.globalService)
    var createFolderUrl;
    if(this.universalService.currentTab == "PrivateFolder"){
      await this.listService.getPPFToken();
      createFolderUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["createPrivateFolder"];
    }else{
      createFolderUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG["commonUrls"]["createFolder"];
    }
        try{
      var result = await this.fileOperationsImplementation.createFolder(folderName,createFolderUrl);
      if(this.universalService.popUpToBeOpened != 'create Folder'){
        if(this.universalService.currentTab == "PrivateFolder"){
          await this.getPrivateFolders("%2DcreatedDate");
        }else{
          await this.getFolders("%2DcreatedDate");
        }
      }
      return Promise.resolve(result);
    } catch(exc){
      this.loggerService.log("folder not created")
      this.universalService.showLoader = false;
      return Promise.reject(exc);
    }
  
  }

async createFolderInsideSharedWithMeFolder(folderName,selectedFolder){
    this.fileOperationsImplementation.setHandler(this.globalService)
    var createNestedSharedFolderUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + "/" + selectedFolder["shareKey"] + ENV_CONFIG.commonUrls["openSharedFolder"] + "/" + selectedFolder["objectKey"];
    try{
      var result = await this.fileOperationsImplementation.createNestedSharedFolder(folderName,createNestedSharedFolderUrl)
      if(this.universalService.popUpToBeOpened != 'create Folder'){ //if creating a folder from copy pop up
        await this.getSharedWithMeFolders("%2DcreatedDate");
      }
      return Promise.resolve(result);
    } catch(exc){
      this.loggerService.log("folder not created")
      this.universalService.showLoader = false;
      return Promise.reject(exc);
    }
  }

  async createFolderInsideTeamFolder(folderName,selectedFolder){
    this.fileOperationsImplementation.setHandler(this.globalService)
    var nestedTFUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["createFolderInsideTeamFolder"];
    var payload = {
      "parentObjectKey":selectedFolder.objectKey,
      "tfKey":selectedFolder.tfKey,
      "objectName":folderName
    }
    try{
      var result = await this.fileOperationsImplementation.createNestedTeamFolder(payload,nestedTFUrl)
      if(result == 'folder created') {
        AppEvents.globalObservable.next({createFolder: false});
        //this.fetchLatestFolders(folderName);
        this.universalService.emptyTab = false;
      }
      return Promise.resolve(result);
    } catch(exc){
      this.loggerService.log("folder not created")
      this.universalService.showLoader = false;
      return Promise.reject(exc);
    }
  }

  async createAlbum(albumName){ //common
    return new Promise(async (resolve, reject)=> {

      try{
        var result = await this.fileOperationsImplementation.createAlbum(albumName)
        if(result){
          resolve(result);
        }
      }catch(exc){
        reject(false);
        this.loggerService.log("folder not created")
      }
    })
   
  }

  removeFolderKeys() { //common
    this.fileOperationsImplementation.setHandler(this.globalService)
    this.fileOperationsImplementation.removeFolderKeys()
    this.getFolders("%2BobjectName");
  }

  async fetchNestedFoldersData(event){
    this.fileOperationsImplementation.setHandler(this.globalService)
    await this.fileOperationsImplementation.fetchNestedFoldersData(event)
    this.getFolders("%2BobjectName");
  }

  async fetchNestedFoldersDataForMobile(event){
    await this.fileOperationsImplementation.fetchNestedFoldersDataForMobile(event);
    this.getFolders("%2BobjectName");
  }

  async fetchNestedPrivateFoldersData(event){
    this.fileOperationsImplementation.setHandler(this.globalService)
    await this.fileOperationsImplementation.fetchNestedFoldersData(event)
    this.getPrivateFolders("%2BobjectName");
  }

  async fetchNestedPrivateFoldersDataForMobile(event){
    await this.fileOperationsImplementation.fetchNestedFoldersDataForMobile(event);
    this.getPrivateFolders("%2BobjectName");
  }

  fetchNestedFoldersDataForShared(event){
    this.fileOperationsImplementation.setHandler(this.globalService)
    this.fileOperationsImplementation.fetchNestedFoldersData(event)
    this.getSharedWithMeFolders("%2BobjectName");
  }

  fetchNestedFoldersDataForTeamFolder(event) {
    this.fileOperationsImplementation.setHandler(this.globalService)
    this.fileOperationsImplementation.fetchNestedFoldersData(event);
    this.getTeamFolders();
  }

  fetchNestedFoldersDataForTeamFolderMobile(event) {
    this.fileOperationsImplementation.setHandler(this.globalService)
    this.fileOperationsImplementation.fetchNestedFoldersData(event);
    this.getTeamFolders();
  }

  fetchNestedFoldersDataForMobileShared(event){
    this.fileOperationsImplementation.fetchNestedFoldersDataForMobile(event);
    this.getSharedWithMeFolders("%2BobjectName");
  }


  async performSelectedOperation(files,operation,correlationId,opType="",moduleType=""){
    var type = this.checkIfTheOperationIsRelatedToShareOrAlbumsOrMyFiles(moduleType);
    if(type == "shared"){
      return this.performSelectedOperationForSharedFiles(files,operation,correlationId);
    }else if (type == "albums"){
      return this.performSelectedOperationForAlbumFiles(files,operation);
    }else if (type == 'myFiles'){
      return this.performSelectedOperationForMyFiles(files,operation,correlationId,opType)
    }else if (type == 'teamFolder'){
      return this.performSelectedOperationForTeamFolderObject(files,operation);
    }else if (type == 'privatefolder'){
      return this.performSelectedOperationForPrivateFolderObject(files,operation,correlationId,opType);
    }
  }

  async performSelectedOperationForMyFiles(files,operation,correlationId,opType=""){
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + "/1.0";
    this.loggerService.log("url for performing the selected operation is ===>>",url)
    var payload = this.fileOperationsImplementation.setPayloadForFileOperations(files,operation,correlationId);
      try{
        switch(operation){
          case "MOVE":
            if(opType == "MOVETOPPF") url = url + "?mppf='/ppf'";
            var result = await this.fileOperationsImplementation.MoveObjects(url,payload);
            if(result['msg'] == "moved successfully"){
              return {"status":"moved successfully","executed operation":"MOVE",'containsIcloudFolder' : result['containsIcloudFolder']};
             }
            break;
          case "TRASH":
            var result = await this.fileOperationsImplementation.deleteObjects(url,payload,files);
            if(result['msg'] == "deleted successfully"){
              return {"status":"success","executed operation":"TRASH",'containsIcloudFolder' : result['containsIcloudFolder']};
             }
            break;
          case "RENAME":
            var result = await this.fileOperationsImplementation.renameObject(url,payload,files);
            if(result == "renamed successfully"){
              return {"status":"success","executed operation":"RENAME"};
             }
             break;
          case "SETFAV":
            var result = await this.fileOperationsImplementation.setObjectAsFavorite(url,payload);
            if(result == "marked as Favorite"){
              return {"status":"success","executed operation":"SETFAV"};
             }
             break;
          case "UNSETFAV":
            var result = await this.fileOperationsImplementation.unSetObjectAsFavorite(url,payload);
            if(result == "unmarked as Favorite"){
              return {"status":"success","executed operation":"UNSETFAV"};
             }
              break;
          case "SETACCESSEDDATE":
            var result = await this.fileOperationsImplementation.setAccessedDate(url,payload);
            if(result == "Accessed date set successfully"){
              return {"status":"success","executed operation":"SETACCESSEDDATE"};
            }
            break;  
        }
      }catch(exc){
        this.loggerService.log("exception in performing selected operation")
        return null;
      }
  }




  async performSelectedOperationForAlbumFiles(files,operation){
    operation = (operation=='TRASH')?"FTR": (operation=='RENAME') ? "FRN" : operation;
    var url =  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["boardURL"] + ENV_CONFIG.commonUrls["albumsMetaData"] + "/update";
    var keyword  = this.getKeyWordForAlbumOperations(operation);
    var payload = this.fileOperationsImplementation.setPayloadForAlbumFileOperations(files,operation,keyword);
    try{
      switch(operation){
        case 'SETFAV':
          var payload = this.fileOperationsImplementation.setPayloadForAlbumFileOperations(files,operation,"FileBookmark");
          var result = await this.fileOperationsImplementation.setAlbumFileAsFavorite(url,payload);
          if(result == "marked as Favorite"){
            return {"status":"success","executed operation":"SETFAV"};
           }
          break;
        case "UNSETFAV":
          var payload = this.fileOperationsImplementation.setPayloadForAlbumFileOperations(files,operation,"FileRemoveBookmark");
          var result = await this.fileOperationsImplementation.unSetAlbumFileAsFavorite(url,payload);
          if(result == "unmarked as Favorite"){
            return {"status":"success","executed operation":"UNSETFAV"};
           }
          break;
        case "FTR": // for deleting the object
        var payload = this.fileOperationsImplementation.setPayloadForAlbumFileOperations(files,operation,"FileDelete");
        var result = await this.fileOperationsImplementation.deleteAlbumFiles(url,payload);
        if(result == "deleted successfully"){
          return {"status":"success","executed operation":"FTR"};
         }
          break;
          
        case "FRN": // for renaming the object
          var payload = this.fileOperationsImplementation.setPayloadForAlbumFileOperations(files,operation,"FileName");
          var result = await this.fileOperationsImplementation.renameAlbumObject(url,payload);
          if(result == "renamed successfully"){
            return {"status":"success","executed operation":"FRN"};
          }
          break
        case "BRN": // for renaming the album
          var payload = this.fileOperationsImplementation.setPayloadForAlbumOperations(files,operation,"Name");
          var result = await this.fileOperationsImplementation.renameAlbumObject(url,payload);
          if(result == "renamed successfully"){
            return {"status":"success","executed operation":"BRN"};
          }
          break
        case "BDU": // for renaming the album desc
          var payload = this.fileOperationsImplementation.setPayloadForAlbumOperations(files,operation,"Desc");
          var result = await this.fileOperationsImplementation.renameAlbumObject(url,payload);
          if(result == "renamed successfully"){
            return {"status":"success","executed operation":"BDU"};
          }
          break   
      }
    }catch(exc){
      this.loggerService.log("exception in performing selected operation for album files",exc)
      return null;
    }
  }

  async performSelectedOperationForTeamFolderObject(files,operation){
    var payload = this.fileOperationsImplementation.setPayloadForTeamFolderObjectOperations(files,operation);
      try{
        switch(operation){
          case "RENAME":
            var url =  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["teamFolderObjectRename"];
            var result = await this.fileOperationsImplementation.renameTFObject(url,payload,files);
            if(result == "renamed successfully"){
              this.cleverTapEventsService.tfObjRename();
              return {"status":"success","executed operation":"RENAME"};
            }
            break;
          case "TRASH":
            var url =  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["nonEntConsoleTeamFolderTrashedObjects"];
            var result = await this.fileOperationsImplementation.deleteTFObjects(url,payload,files);
            if(result == "deleted successfully"){
              this.cleverTapEventsService.tfObjectDeleteFromtf();
              return {"status":"success","executed operation":"TRASH"};
            }
            break;
        }
      }catch(exc){
        this.loggerService.log("exception in performing selected operation")
        return null;
      }
  }

  async updateSummaryCounts(tab){ 

    var summaryUrl,fetchFolderData;
    const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
    const currentPrivateFolderKey = this.sessionStorageService.getCurrentPrivateFolderKey(true) == false? "":this.sessionStorageService.getCurrentPrivateFolderKey(true);
    if(this.universalService.currentTab == "PrivateFolder" && currentPrivateFolderKey!="" && currentPrivateFolderKey != this.localStorageSvc.getPrivateFolderKey()){
      summaryUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + '/ppf/summary?folderKey='+currentPrivateFolderKey;
      fetchFolderData = true; 
    }else if (this.universalService.currentTab == "PrivateFolder") {
      summaryUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + '/ppf/summary?folderKey=' 
      fetchFolderData = false;
    }else if (currentFolderKey && tab == 'allfiles') {
        summaryUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + '/summary?folderKey=' + currentFolderKey
        fetchFolderData = true;
    } 
    else {
        fetchFolderData = false;
        summaryUrl= ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + '/summary?folderKey='
    }
    try {
        let classRef = this;
        var result = await this.fileOperationsImplementation.updateSummaryCounts(summaryUrl,tab,fetchFolderData);
        await this.setGlobalCountForfilters(result)
        this.loggerService.log("fetch summary result", result);
    } catch(ex){
      console.log("summery call failed",ex)
    }
  }
  setGlobalCountForfilters(obj){
    this.universalService.priviewAudioFileCount = 0;
    if(obj.audio) {//If audio exist
      obj.audio.forEach(obj => {
        this.universalService.priviewAudioFileCount = this.universalService.priviewAudioFileCount + parseInt(obj.fileCount)
    });
    }
  }
  async setAccessedDate(file){ 
    if(window.location.href.includes("sharedwithme")){
      await this.dcGroupCodePicker.decideTypeOfShare(file.shareKey);
      var url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["recentlyAccessed"] + file.objectKey + "?shareKey=" + file.shareKey;
    }else{
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + ENV_CONFIG.commonUrls["recentlyAccessed"] + file.objectKey;
    }
    var result = await this.fileOperationsImplementation.setAccessedDate(url,file);
  }

  async getSuggestedEmails(file){
    
    var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["contactsURL"] + ENV_CONFIG.commonUrls["amikoCab"]
    this.fileOperationsImplementation.setHandler(this.globalService)
    var result = await this.fileOperationsImplementation.getUserContactsEmails(url);
    return result;
  }

  async openFolder(folder) {
    var result;
    // await this.homeController.fetchSummary();
    // this.getAllFiles();    
    result = await this.fileOperationsImplementation.openFolder(folder);
   
    return result;
  }

  async performSelectedOperationForSharedFiles(files,operation,correlationId){
    var payload = this.fileOperationsImplementation.setPayloadForCollabShareFileOperations(files,operation);
    let endpoint = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"];
    if(files.length == 1 || (files["shareKey"] && operation == "RENAME")){
      let shareKey = operation == "RENAME" ? files.shareKey : (files[0].shareKey ? files[0]["shareKey"] : files[0]["FullObject"]["shareKey"])
      await this.dcGroupCodePicker.decideTypeOfShare(shareKey)
      endpoint = SHARE_DC["DC_URLS"]["nmsURL"];
    }
    
    try{
      switch(operation){
        case "TRASH":
          var url = endpoint + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["collabShare"] + ENV_CONFIG.commonUrls["trashCollabShare"];
          var result = await this.fileOperationsImplementation.deleteObjects(url,payload,files);
          if(result['msg'] == "deleted successfully"){
            return {"status":"success","executed operation":"TRASH",'containsIcloudFolder' : result['containsIcloudFolder']};
           }
          break;
        case "RENAME":
          var url = endpoint + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["collabShare"] + "/"+files.shareKey + ENV_CONFIG.commonUrls["rename"];
          var result = await this.fileOperationsImplementation.renameObject(url,payload,files);
          if(result == "renamed successfully"){
            return {"status":"success","executed operation":"RENAME"};
           }
           break;
        case "SETACCESSEDDATE":
          return this.performSelectedOperationForMyFiles(files,operation,correlationId);    
      }
    }catch(exc){
      this.loggerService.log("exception in performing selected operation")
      return null;
    }
  }

  checkIfTheOperationIsRelatedToShareOrAlbumsOrMyFiles(moduleType=""){ // module type is added to check the type of module the edit is opened from and user the respective delete functionality when user selects replace original image from the photo edit
    if(this.universalService.showPreview && this.universalService.selectedFile?.previewFromUpload){
      return this.checkIfTheOperationIsRelatedToShareOrAlbumsOrMyFilesWhenPreviewFromUpload()
    }
    if((this.universalService.currentTab == 'fileinfo' && this.universalService.inAppWebViewOpened)){
      if(this.universalService.selectedFile["tfKey"]){
        return "teamFolder";
      }else{
        return "shared";
      }
    }else if(window.location.href.indexOf("album") > -1 || moduleType == "albums"){
      return "albums"
    }else if(this.router.url.includes('shared') || moduleType == "share"){
      return "shared"
    }else if(window.location.href.indexOf("teamfolder") > -1 || this.universalService.searchType == 'teamfolder' || moduleType == "teamfolder"){
      return "teamFolder";
    }else if(window.location.href.indexOf("privatefolder") > -1 || moduleType == "privatefolder"){
      return "privatefolder";
    }else{
      return "myFiles"
    }
  }


  checkIfTheOperationIsRelatedToShareOrAlbumsOrMyFilesWhenPreviewFromUpload(){
    let uploadInitiatedModule = "";
    if(this.universalService.showPreview){
      uploadInitiatedModule = this.universalService.selectedFile["uploadInitiatedModule"];
    }
    // if((this.universalService.currentTab == 'fileinfo' && this.universalService.inAppWebViewOpened)){
    //   if(this.universalService.selectedFile["tfKey"]){
    //     return "teamFolder";
    //   }else{
    //     return "shared";
    //   }
    // }else 
    if(uploadInitiatedModule == "Album Details"){
      return "albums"
    }else if(uploadInitiatedModule == "sharedFiles"){
      return "shared"
    }else if(uploadInitiatedModule == "teamfolders"){
      return "teamFolder";
    }else if(uploadInitiatedModule == "PrivateFolder"){
      return "privatefolder";
    }else{
      return "myFiles"
    }
  }

  checkIfFolderKeysIsEmpty(){
    if(this.fileOperationsImplementation.folderKeys.length == 1 && this.fileOperationsImplementation.folderKeys[0]==""){
      this.fileOperationsImplementation.folderKeys[0] = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    }
  }

  getKeyWordForAlbumOperations(operation){
    var album = this.universalService.currentAlbum;
    switch(operation){
      case 'SETFAV':
        return 'FileBookmark';
      case 'UNSETFAV':
        return 'FileRemoveBookmark';
      case 'FRN':
        return 'FileName';
      case 'FTR':
        return 'FileDelete';
    }
  }

  async performSelectedOperationForPrivateFolderObject(files,operation,correlationId,opType=""){
    await this.listService.getPPFToken();
    var payload = this.fileOperationsImplementation.setPayloadForPrivateFolderObjectOperations(files,operation,correlationId);
    this.universalService.isPrivateFolderTokenRequired = true;
      try{
        switch(operation){
          case "RENAME":
            var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["privateFolderRename"];
            var result = await this.fileOperationsImplementation.renamePFObject(url,payload,files);
            if(result == "renamed successfully"){
              return {"status":"success","executed operation":"RENAME"};
            }
            break;
          case "TRASH":
            var url =  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["privateFolderDelete"];
            var result = await this.fileOperationsImplementation.deletePFObjects(url,payload,files);
            if(result == "deleted successfully"){
              return {"status":"success","executed operation":"TRASH"};
            }
            break;
          case "MOVE":
            var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["metaData"] + "/1.0";
            if(opType == "MOVETOPPF") url = url + "?mppf='/ppf'";
            var result = await this.fileOperationsImplementation.MoveObjects(url,payload);
            if(result['msg'] == "moved successfully"){
              await this.fileOperationsImplementation.addToDBForMoveCopy("", "MOVEOUTOPF") 
              return {"status":"moved successfully","executed operation":"MOVE",'containsIcloudFolder' : result['containsIcloudFolder']};
             }
            break;
        }
      }catch(exc){
        this.loggerService.log("exception in performing selected operation")
        return null;
      }
  }

}